// @NOTE this way to set the styles no longer works for components,
// since material changed the way it handles disabled and errored states
// If we need to support light and dark colors/background for texts we'll need to handle
// dark and light themes, and render components on the theme context. I'm patching fow now,
// to avoid showing orange colors to our users. But this is far from the best/correct solution.

const styles = (theme) => ({
  'light-textFieldSelectMenu': {
    color: theme.colors.text_secondary
  },
  'light-textFieldIcon': {
    color: theme.colors.text_secondary
  },
  'light-labelRoot': {
    color: theme.colors.text_secondary,
    whiteSpace: 'nowrap',
    zIndex: 1
  },
  'light-labelFocused': {
    color: `${theme.colors.text_secondary} !important`
  },
  'light-labelDisabled': {
    color: `${theme.colors.text_secondary} !important`,
    opacity: 1
  },
  'dark-labelRoot': {
    whiteSpace: 'nowrap',
    left: 'inherit',
    zIndex: 1
  },
  'light-inputRoot': {
    backgroundColor: theme.colorPalette.white,
    '&.Mui-error': {
      border: `1px solid ${theme.colorPalette.red_50}`
    }
  },
  'light-textFieldDisabled': {
    color: `${theme.colorPalette.green_75} !important`
  },
  'light-labelShrink': {
    width: '100%',
    textAlign: 'initial',
    overflow: 'visible'
  },
  'dark-textFieldDisabled': {
    color: `${theme.colorPalette.white} !important`
  },
  'dark-inputRoot': {
    backgroundColor: theme.colorPalette.white_op_10,
    '&.Mui-error': {
      border: `1px solid ${theme.colorPalette.red_50}`
    }
  },
  'dark-textFieldIcon': {
    color: theme.colors.button__background_secondary
  },
  caret: {
    width: 24,
    cursor: 'pointer',
    height: 24,
    position: 'absolute',
    top: 7,
    right: 6
  },
  select: {
    backgroundColor: 'inherit',
    '&$selected:focus': {
      backgroundColor: 'inherit'
    },
    '&.Mui-disabled': {
      color: theme.colors.black
    }
  },
  selected: {
    backgroundColor: 'inherit',
    '&:focus': {
      backgroundColor: 'inherit'
    }
  },
  selectIcon: {
    width: 32,
    height: 32,
    marginRight: 4
  },
  empty: {
    color: theme.colorPalette.grey_10_op_38
  }
});

export default styles;
